module.exports = __webpack_public_path__ + "static/WOSB-9643a218dad8176220940810852bf39f.png";